export const pt = {
    slugError:`Slug não identificado, solicite novo link`,

    // Títulos principais
    remocaoDados: "Remoção de Dados Pessoais",
    solicitarExclusao: "Solicite a exclusão, bloqueio ou anonimização dos seus dados pessoais",
    
    // Seções
    dadosIdentificacao: "Dados de Identificação",
    tipoSolicitacao: "Tipo de Solicitação",
    confirmacoesObrigatorias: "Confirmações Obrigatórias",
    
    // Campos do formulário
    nomeCompleto: "Nome Completo",
    emailCadastrado: "E-mail Cadastrado",
    cpf: "CPF",
    telefone: "Telefone/Celular",
    solicitacao: "Se preferir, conte-nos abaixo o motivo da exclusão da sua conta.",
    
    // Placeholders
    placeholderNome: "Seu nome completo",
    placeholderEmail: "seu@email.com",
    placeholderCpf: "000.000.000-00",
    placeholderTelefone: "(00) 00000-0000",
    placeholderMotivo: "Descreva brevemente o motivo da sua solicitação",
    
    // Opções do select
    selecioneOpcao: "Selecione uma opção",
    exclusaoCompleta: "Exclusão completa dos dados pessoais",
    bloqueioDados: "Bloqueio dos dados pessoais",
    anonimizacao: "Anonimização dos dados pessoais",
    portabilidade: "Portabilidade dos dados para outra plataforma",
    cancelamentoConta: "Cancelamento de conta e exclusão de dados",
    
    // Caixa de informações
    exercendoDireito: "🔒 Exercendo seu Direito à Privacidade",
    infoPrivacidade: "Conforme estabelecido em nossa Política de Privacidade e pela Lei Geral de Proteção de Dados (LGPD), você tem o direito de solicitar a exclusão, bloqueio ou anonimização dos seus dados pessoais.",
    infoImportante: "Importante:",
    infoPerda: "Ao solicitar a remoção dos seus dados, você perderá acesso às funcionalidades da plataforma e não poderá recuperar seu histórico de atividades.",
    
    // Aviso de atenção
    atencao: "⚠️ Atenção:",
    avisoIrreversivel: "Esta ação é irreversível. Após a confirmação da exclusão dos seus dados, não será possível recuperar seu cadastro, histórico de assinaturas, preferências ou qualquer outro dado associado à sua conta.",
    
    // Confirmações (checkboxes)
    confirmacao1: "Confirmo que sou o titular dos dados pessoais informados e tenho conhecimento de que esta solicitação resultará na perda permanente do acesso à plataforma.",
    confirmacao2: "Estou ciente de que a exclusão dos dados pessoais é irreversível e que não poderei recuperar meu cadastro, histórico ou qualquer informação associada à minha conta.",
    confirmacao3: "Compreendo que alguns dados podem ser mantidos por obrigação legal (como registros de transações para fins fiscais) mesmo após esta solicitação, conforme previsto na LGPD.",
    confirmacao4: "Li e concordo com os termos da Política de Privacidade e entendo os efeitos desta solicitação de remoção de dados.",

    // Buttons and actions
    enviar: "Enviar",
    enviando: "⏳ Enviando...",
    
    // Informações de tempo
    prazoProcessamento: "Sua solicitação será processada em até 72 horas",
    
    // Informações de contato
    precisaAjuda: "📞 Precisa de Ajuda?",
    email: "E-mail:",
    prazoResposta: "Prazo de Resposta:",
    prazoRespostaTexto: "Até 72 horas",
    infoEquipe: "Nossa equipe está disponível para esclarecer dúvidas sobre o processo de remoção de dados.",
    
    // Mensagens de validação
    confirmeItensObrigatorios: "Por favor, confirme todos os itens obrigatórios antes de prosseguir.",
    corrigirCampos: "Por favor, corrija os campos destacados antes de prosseguir.",
    solicitacaoEnviada: "Solicitação enviada com sucesso! Você receberá uma confirmação por e-mail em até 72 horas úteis.",
    erroEnvio: "Erro ao enviar solicitação. Tente novamente.",
    
    // Campo obrigatório
    obrigatorio: "*",

    rules: {
        fullName: "Nome Completo",
        email: "E-mail",
        request: "Solicitação",
        isHolder: "Confirmo que sou o titular dos dados pessoais informados e tenho conhecimento ...",
        isAware: "Estou ciente de que a exclusão dos dados pessoais é irreversível ...",
        understandLegal: "Compreendo que alguns dados podem ser mantidos por obrigação legal ...",
        agreeTerms: "Li e concordo com os termos da Política de Privacidade ...",
    }
};

export const en = {
    slugError:`unexpected slug, contact suport`,

    // Main titles
    remocaoDados: "Personal Data Removal",
    solicitarExclusao: "Request deletion, blocking or anonymization of your personal data",
    
    // Sections
    dadosIdentificacao: "Identification Data",
    tipoSolicitacao: "Request Type",
    confirmacoesObrigatorias: "Required Confirmations",
    
    // Form fields
    nomeCompleto: "Full Name",
    emailCadastrado: "Registered Email",
    cpf: "Tax ID (CPF)",
    telefone: "Phone/Mobile",
    solicitacao: "If you prefer, tell us below the reason for your account deletion.",
    
    // Placeholders
    placeholderNome: "Your full name",
    placeholderEmail: "your@email.com",
    placeholderCpf: "000.000.000-00",
    placeholderTelefone: "(00) 00000-0000",
    placeholderMotivo: "Briefly describe your request",
    
    // Select options
    selecioneOpcao: "Select an option",
    exclusaoCompleta: "Complete deletion of personal data",
    bloqueioDados: "Blocking of personal data",
    anonimizacao: "Anonymization of personal data",
    portabilidade: "Data portability to another platform",
    cancelamentoConta: "Account cancellation and data deletion",
    
    // Information box
    exercendoDireito: "🔒 Exercising Your Privacy Rights",
    infoPrivacidade: "As established in our Privacy Policy and by the General Data Protection Law (LGPD), you have the right to request deletion, blocking or anonymization of your personal data.",
    infoImportante: "Important:",
    infoPerda: "By requesting the removal of your data, you will lose access to platform features and will not be able to recover your activity history.",
    
    // Warning notice
    atencao: "⚠️ Warning:",
    avisoIrreversivel: "This action is irreversible. After confirming the deletion of your data, it will not be possible to recover your account, subscription history, preferences or any other data associated with your account.",
    
    // Confirmations (checkboxes)
    confirmacao1: "I confirm that I am the owner of the personal data provided and am aware that this request will result in permanent loss of access to the platform.",
    confirmacao2: "I am aware that the deletion of personal data is irreversible and that I will not be able to recover my account, history or any information associated with my account.",
    confirmacao3: "I understand that some data may be retained for legal obligation (such as transaction records for tax purposes) even after this request, as provided by LGPD.",
    confirmacao4: "I have read and agree to the terms of the Privacy Policy and understand the effects of this data removal request.",
    
    // Buttons and actions
    enviar: "Send",
    enviando: "⏳ Sending...",
    
    // Time information
    prazoProcessamento: "Your request will be processed within 72 business hours",
    
    // Contact information
    precisaAjuda: "📞 Need Help?",
    email: "Email:",
    prazoResposta: "Response Time:",
    prazoRespostaTexto: "Up to 72 business hours",
    infoEquipe: "Our team is available to clarify questions about the data removal process.",
    
    // Validation messages
    confirmeItensObrigatorios: "Please confirm all required items before proceeding.",
    corrigirCampos: "Please correct the highlighted fields before proceeding.",
    solicitacaoEnviada: "Request sent successfully! You will receive a confirmation email within 72 business hours.",
    erroEnvio: "Error sending request. Please try again.",
    
    // Required field
    obrigatorio: "*",

    

    rules: {
        fullName: "Full Name",
        email: "Email",
        request: "Request",
        isHolder: "I confirm that I am the owner of the personal...",
        isAware: "I am aware that the deletion of personal data...",
        understandLegal: "I understand that some data may be retained for legal obligation...",
        agreeTerms: "I have read and agree to the terms of the Privacy Policy...",
    }
};